import { HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { extractFilenameFromHeaders, MS_PER_MINUTE } from '@skylab-shared/utils';
import { AxiosResponse } from 'axios';
import { ExportQueryParameters } from '../../common/export/export-query.parameters';
import { ExportResult } from '../../common/export/export-query.result';
import { ExportQuery } from '../../common/export/export.query-base';


export interface ClientsEppExportParameters extends ExportQueryParameters { search: string; }

export class ClientsEppExportQuery extends ExportQuery<ExportResult> {
    public constructor(parameters: ExportQueryParameters) {
        super(parameters);
    }
}

export class ClientsEppExportQueryHandlerBase implements QueryHandler<ClientsEppExportQuery, ExportResult> {
    private static Url = TaggedUrl.join('clients/epp/export', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync({ parameters }: ClientsEppExportQuery): Promise<ExportResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                columns: parameters.columns
            }
        };

        const response = await this.http.post<Blob>(ClientsEppExportQueryHandlerBase.Url, requestData, { responseType: 'blob', timeout: 3 * MS_PER_MINUTE });

        return {
            file: response.data,
            filename: extractFilenameFromHeaders(<AxiosResponse>response) || ''
        };
    }
}
